<main class="d-flex flex-column h-100 bg-white">
  <ng-track-move
    *ngIf="(store$ | async) as store"
    [fromTrackData]="store.trackMoveState.fromTrackData"
    [inventoryTrackData]="store.trackMoveState.tracks"
    [toTrackData]="store.trackMoveState.toTrackData"
    [loading]="store.trackMoveState.loading"
    [loadingToTrack]="store.trackMoveState.loadingToTrack"
    [selectedToTrack]="store.trackMoveState.selectedToTrack"
    [selectedFromTrack]="store.trackMoveState.selectedFromTrack"
    [fromTrackEquipments]="store.trackMoveState.fromTrackEquipments"
    [toTrackEquipments]="store.trackMoveState.toTrackEquipments"
    [performTrackMoves]="store.authorizations?.canDoTrackMoves"
    (toTrackSelected)="dispatchSelectedToTracK($event)"
    (moveTrack)="dispatchMoveTrack($event)"
  ></ng-track-move>
</main>
